import { Injectable } from '@angular/core';
import * as color from '../../config/colors';
import * as backgroundColor from "../../config/backgroundColor";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as timeline from "../../config/timeline";
import * as geo from "../../config/geo";
import * as visualMaps from '../../config/visualMap';
import * as series from '../../config/series';
import * as textStyle from '../../config/textStyle';
import * as _ from 'lodash';
import { CommonService } from '../../service/common.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';

@Injectable({
  providedIn: 'root'
})
export class ScatterMapService {

  constructor(
    private commonService: CommonService,
    private darkModeService: ChartDarkModeService
  ) { }


  getScatterMapDefaultOptions() {
    let style = this.commonService.changeFontSize();
    let dimension = 2;

    let defaultOption = {
      backgroundColor: backgroundColor.backgroundColor,
      color: color.defaultColors,
      // toolbox: toolbox.getToolboxBasicMenu(),
      geo: geo.getCommonGeo(style, 'myMap'),
      visualMap: visualMaps.getVisualMapOfPiecewise(style, dimension),
      tooltip: tooltip.getTooltipOfPointMap(),
      series: [series.getScatterOfMapSeries(style)],
      textStyle: textStyle.getTextStyle()
    }
    return defaultOption;
  }

  changeChartData(chartOptions, chartData: { name: string, value: any[] }[]) {
    chartOptions.series[0].data = chartData;
  }

  // 更改visualMap
  changeVisualMap(chartOption, visualMapPosition: 'left' | 'right', visualMap, dimension: number = 2, isDarkMode: boolean = false) {
    let style = this.commonService.changeFontSize();

    if (!_.isEmpty(visualMap)) {
      if (visualMap.type === 'continuous') {
        chartOption.visualMap = visualMaps.getVisualMapOfContinuous(style, dimension, visualMap.data.min, visualMap.data.max);
        if (visualMap.data.hasOwnProperty('color') && visualMap.data.color.length > 0) {
          chartOption.visualMap.inRange.color = visualMap.data.color;
        }
      } else if (visualMap.type === 'piecewise') {
        if (visualMap.hasOwnProperty('data') && Array.isArray(visualMap.data)) {
          chartOption.visualMap = visualMaps.getVisualMapOfPiecewise(style, dimension, visualMap.data)
        } else {
          chartOption.visualMap = visualMaps.getVisualMapOfPiecewise(style, dimension)
        }
      }
    } else {
      chartOption.visualMap = visualMaps.getVisualMapOfPiecewise(style, dimension)
    }

    this.openDarkMode(chartOption, isDarkMode)
    this.changeVisualMapPosition(chartOption, visualMapPosition);
  }

  // 更改visualmap 维度
  changeVisualmapDimension(chartOptions, dimension) {
    chartOptions.visualMap.dimension = dimension;
  }

  // 修改维度名称 
  changeDimensionNames(chartOption, dimensionNames: { [key: string]: string }[]) {
    let names = [], units = [];
    if (!dimensionNames) {
      return;
    }

    for (const iterator of dimensionNames) {
      names.push(iterator.dimensionName)
      units.push(iterator.unit)
    }

    let pointName = ['lng', 'lat'];
    pointName = pointName.concat(names);


    chartOption.series[0].dimensions = pointName;

    chartOption.tooltip = tooltip.getTooltipOfPointMap(units);
  }

  //修改visualmap位置
  changeVisualMapPosition(chartOption, position: 'left' | 'right') {
    switch (position) {
      case 'left':
        chartOption.visualMap.left = 0;
        delete chartOption.visualMap.right;
        break;
      case 'right':
        chartOption.visualMap.right = 0;
        delete chartOption.visualMap.left;
        break;
      default:
        chartOption.visualMap.left = 0;
        delete chartOption.visualMap.right;
        break;
    }
  }

  // changeToolboxShow(chartOption, toolboxShow: boolean) {
  //   if (typeof (toolboxShow) === 'boolean') {
  //     chartOption.toolbox.show = toolboxShow;
  //   }
  // }


  // 更改geoLabel显示状态
  changeGeoShowLabel(chartOption, show: boolean) {
    if (show) {
      chartOption.geo.label.show = show
      chartOption.geo.emphasis.label.show = show;
    }
  }

  // 开启黑暗模式
  openDarkMode(chartOption, darkMode) {
    if (typeof (darkMode) === 'string') {
      chartOption.backgroundColor = darkMode;
    } else if (darkMode) {
      this.darkModeService.setMapDarkMode(chartOption)
    }
  }


}
